import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { FastField, FieldProps } from 'formik';
import React from 'react';
import { JobTypeOptions as jobTypeOptions } from '../../../constants/jobType';

interface JobTypeFastFieldProps {
  name: string;
  label: string;
  [x: string]: any;
}

const JobTypeFastField: React.FC<JobTypeFastFieldProps> = props => {
  const { name, label, ...other } = props;
  return (
    <FastField name={name}>
      {({
        field, // { name, value, onChange, onBlur }
        form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: FieldProps<any>) => {
        return (
          <FormControl fullWidth>
            <InputLabel id={name}>{label}</InputLabel>
            <Select
              labelId={name}
              onChange={(
                event: React.ChangeEvent<{
                  value: unknown;
                }>,
              ) => {
                form.setFieldValue(name, event.target.value as string);
              }}
              {...field}
              {...other}
            >
              {jobTypeOptions.map(jobType => (
                <MenuItem key={jobType.value} value={jobType.value}>
                  {jobType.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }}
    </FastField>
  );
};

export default JobTypeFastField;
